import { render, staticRenderFns } from "./groupFooterButton.vue?vue&type=template&id=0902fde8&"
import script from "./groupFooterButton.vue?vue&type=script&lang=js&"
export * from "./groupFooterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports